import React from 'react';
import styled from 'styled-components';
import datepickerBlackIcon from '../../../assets/icon/datepicker-black.webp';
import datepickerWhiteIcon from '../../../assets/icon/datepicker-white.webp';
import navBlackIcon from '../../../assets/icon/nav-black.webp';
import navWhiteIcon from '../../../assets/icon/nav-white.webp';
import { formatDate } from 'utils/common';
import imgPlaceholder from '../../../assets/icon/placeholder.webp';


interface ShowCardProps {
  image: string;
  title: string;
  startDate: string;
  endDate: string;
  location: string;
}
interface CardContainerProps {
  hasImage: boolean;
}

export const ShowCard: React.FC<ShowCardProps> = ({
  image,
  title,
  startDate,
  endDate,
  location,
}) => {
  return (
    <CardContainer hasImage={image ? true : false}>
      {image ? <CardImage src={image} alt={title} /> : <PlaceholderImage src={imgPlaceholder} alt="No image available" />}
      <CardContent hasImage={image ? true : false}>

        <CardTitle>{title}</CardTitle>
        <DateContainer>
          <DateIcon
            src={image ? datepickerWhiteIcon : datepickerBlackIcon}
            alt="Date"
          />
          <DateText>
            {formatDate(startDate)} - {formatDate(endDate)}
          </DateText>
        </DateContainer>
        <LocationContainer>
          <LocationIcon
            src={image ? navWhiteIcon : navBlackIcon}
            alt="Location"
          />
          <LocationText>{location}</LocationText>
        </LocationContainer>
      </CardContent>
    </CardContainer>
  );
};

const CardContainer = styled.article<CardContainerProps>`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  position: relative;
  min-width: 240px;
  min-height: 220px;
  padding: 138px 10px 15px;
  width: 209px;
  background-color: #ECEBEB;
  justify-content: end;
  ${props => props.hasImage && `
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 50%;
      background: linear-gradient(
        to top,
        rgba(0, 0, 0, 0.8) 0%,
        rgba(0, 0, 0, 0.4) 50%,
        transparent 100%
      );
      border-radius: 0 0 16px 16px;
      pointer-events: none;
      z-index: 1;
    }
  `}
  @media (max-width: 991px) {
    padding-top: 100px;
  }
`;

const CardImage = styled.img`
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 16px;
`;

const PlaceholderImage = styled.img`
  width: 37.5px;
  height: 37.5px;
  object-fit: contain;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const CardContent = styled.div<CardContainerProps>`
  position: relative;
  display: flex;
  width: 100%;
  max-width: 240px;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  z-index: 2;
  color:black;
  ${props => props.hasImage && `
    color:#ffffff !important;
  `}
`;

const CardTitle = styled.h3`
  align-self: stretch;
  gap: 10px;
  font-family: Inter, -apple-system, Roboto, Helvetica, sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.13px;
  line-height: 1.2;
  margin: 0 0 5px;
  font-size: 13px;
  font-family: 'Inter';
  font-weight: 600;
`;

const DateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
  text-transform: uppercase;
  justify-content: start;
`;

const DateIcon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 12px;
  align-self: stretch;
  margin-top: auto;
  margin-bottom: auto;
  flex-shrink: 0;
`;

const DateText = styled.time`
  align-self: stretch;
  margin-top: auto;
  margin-bottom: auto;
  font-size: 12px;
  font-family: 'Inter';
  font-weight: 600;
`;

const LocationContainer = styled.div`
  display: flex;
  margin-top: 4px;
  align-items: center;
  gap: 13px;
  white-space: nowrap;
  text-transform: capitalize;
  justify-content: start;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const LocationIcon = styled.img`
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 12px;
  flex-shrink: 0;
`;

const LocationText = styled.p`
  align-self: stretch;
  margin-top: auto;
  margin-bottom: auto;
  font-size: 12px;
  font-family: 'Inter';
  font-weight: 600;
`;
